import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { DetailCard, DetailCardTitle } from '@/components/molecules/sales-manager/detail-card'
import { DailySummary } from '@/models/sales-manager/detail'

type Props = {
  salesTotalDetail: DailySummary
}

export const BalanceSheet: React.FC<Props> = props => {
  const { t } = useTranslation()

  return (
    <DetailCard>
      <DetailCardTitle>{t('Balance Sheet')}</DetailCardTitle>
      <div css={cardContainerStyle}>
        <div className="debit-block">
          <div className="title">{t('Debits')}</div>
          <div className="summary-line">
            <div>{t('Deposit')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitSummary.paymentTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line" style={{ textIndent: '1rem' }}>
            <div>{t('P/D Receivable Collection')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitSummary.prevUnpaidPaymentTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div>{t('P/D Deposit Release')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitSummary.prevDepositTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line" style={{ textIndent: '1rem' }}>
            <div>{t('Advance Payment Release')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitSummary.reverseOfAdvanceMoney.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div>{t('Accounts Receivable Balance')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitSummary.accountsReceivableBalance.toLocaleString()}</div>
          </div>
          <div className="total-line">
            <div>{t('Total')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.debitTotal.toLocaleString()}</div>
          </div>
        </div>

        <div className="credit-block">
          <div className="title">{t('Credits')}</div>
          <div className="summary-line">
            <div>{t('Sales')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.creditSummary.salesTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div>{t('Today’s Deposits')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.creditSummary.depositTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div>{t('P/D Receivable Carry-over')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.creditSummary.prevAccountsReceivableBalance.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div>{t('Today’s Temporary Receipts')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.creditSummary.temporaryTotal.toLocaleString()}</div>
          </div>
          <div className="summary-line">
            <div style={{ height: '1em' }}></div>
          </div>
          <div className="total-line">
            <div>{t('Total')}</div>
            <div>¥{props.salesTotalDetail.balanceSheet.creditTotal.toLocaleString()}</div>
          </div>
        </div>
      </div>
    </DetailCard>
  )
}

const cardContainerStyle = css({
  fontSize: 14,
  display: 'flex',
  padding: '0 32px 24px 32px',
  gap: 32,
  '.debit-block, .credit-block': { width: '50%' },
  '.title': {
    lineHeight: 2,
    textAlign: 'center',
    background: '#F5F5F5',
  },
  '.summary-line': {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12,
    ':first-of-type': { marginTop: 0 },
  },
  '.total-line': {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    borderTop: '1px solid #f2f2f2',
    marginTop: 18,
    paddingTop: 18,
  },
})
